import { cn } from '@utils'

export default function Input({
  className,
  icon,
  inputClassName,
  error,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement> & {
  inputClassName?: string
  icon?: React.ReactNode
  error?: string
}) {
  return (
    <div>
      <div
        className={cn(
          'group/input border-b transition-colors duration-500 border-secondary/30 flex items-center gap-x-2 focus-within:border-secondary',
          { '!border-red-500': Boolean(error) },
          className
        )}
      >
        <input
          type='text'
          className={cn('flex-1 h-15', inputClassName)}
          {...props}
        />
        {icon && (
          <span
            className={cn(
              'shrink-0 text-secondary/30 group-focus-within/input:text-secondary transition-colors duration-500',
              { '!text-red-500': Boolean(error) }
            )}
          >
            {icon}
          </span>
        )}
      </div>
      {
        error && (
          <p className='text-sm text-red-500 mt-1'>{error}</p>
        )
      }
    </div>
  )
}
